import {
  width, maxHeight, space, color, themeGet,
} from 'styled-system';
import styled, { injectGlobal } from 'react-emotion';
import { Button, Icon, List } from 'antd';

export const SubNavigationBar = styled('section')`
  ${width}
  ${space}
  ${color}
  height: 48px;
  min-height: 48px; 
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: 'proxima-nova', sans-serif;
  border-bottom: 1px solid ${themeGet('colors.greyscale.3')};
  overflow-y: hidden; /* This is added to prevent IE11 making the bar changing heights in weird manner. */

  h3 {
    margin: 0;
    font-weight: bold;
    display: inline-block;
  }

  section .ant-divider-vertical {
    margin: 0 18px;
    height: 1.2em;
  }

  section {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
`;

export const SubNavButton = styled(Button)`
  ${space}
  ${width}
  ${props => props.float && { float: props.float }}
  &.ant-btn.ant-btn-button {
    ${color};
    border: 0;
    transition: all .3s;
    &:hover {
      border: 0;
    }
    &:active {
      transform: scale(0.95);
    }
    ::after {
      display: none;
    }
  }
  ${props => props.disabled && { opacity: 0.25 }}
`;

export const SubNavIcon = styled(Icon)`
  ${space}
  ${color}
`;

export const ProgressListWrapper = styled('div')` &&& {
  .ant-list {
    min-height: 100px;
    border-bottom: 1px solid ${themeGet('colors.greyscale.3')};
    overflow-y: scroll;
    font-size: 13px !important;

    .ant-list-item {
      padding: 4px 12px;
    }

    .ant-list-item-meta {
      margin-left: 28px;
      flex: 1 400px;
    }

    .ant-list-item-content-single {
      margin-left: 16px;
      line-height: 1.2;
    } 

    .ant-list-item-extra-wrap {
      width: 95%;
    }

    .ant-list-item-meta-content > * {
      font-size: 13px !important;
      line-height: 1.2 !important;
    }
  }
}`;

export const ProgressList = styled(List)` &&& {
  ${maxHeight}
}`;

export const TrianglePointer = styled('div')`
  width: 0; 
  height: 0; 
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent; 
  border-left: 6px solid ${themeGet('colors.greyscale.2')};
  position: absolute;
  left: 12px;

  /* Useful hack adding styles targeting only to IE10 up */
  @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {  
    margin-top: -6px;
  }
`;

export const TimeStamp = styled('small')`
  ${color}
`;

export const OptimisePanelWrapper = styled('div')`
  & > div {
    margin-top: 16px;
  }
`;

export const Footer = styled('div')`
  border-top: 1px solid ${themeGet('colors.greyscale.5')};
  padding: 9px;
  & > * {
    margin-right: 9px;
    font-size: 90%;
  }
`;

injectGlobal(`
  .DCRPOptimisePopover {
    .ant-popover-inner-content {
      padding: 0;
      width: 45vw;
    }
  }

  .DCRPOptimiseIssues {
    .ant-collapse-header {
      font-weight: 500;
      padding: 4px 0 6px 36px;
      width: 100%
    }
  
    .ant-collapse-content-box {
      padding: 0 !important;
    }

    .ant-list {
      min-height: 100px;
      border-bottom: 1px solid ${themeGet('colors.greyscale.3')};
      font-size: 13px !important;
  
      .ant-list-item {
        padding: 4px 12px;
      }
  
      .ant-list-item-meta {
        margin-left: 28px;
        flex: 1 400px;
      }
  
      .ant-list-item-content-single {
        margin-left: 16px;
        line-height: 1.2;
      } 
  
      .ant-list-item-extra-wrap {
        width: 95%;
      }
  
      .ant-list-item-meta-content > * {
        font-size: 13px !important;
        line-height: 1.2 !important;
      }
    }
  }
`);

export const WeekSequenceIndicator = styled('div')` &&& {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px 5px;
  border-radius: 3px;
  color: #fff;
  margin: 2px 0px 2px 4px;
  text-transform: capitalize;
  ${color}
  width: fit-content;
  height: fit-content;
  font-size: 1.05em;
  font-weight: 900;
}`;
